import { OTP_SCOPES } from "@utils/enum";

export const buildPayloadByScope = (scope, userDetails) => {
  const resultPayload = { scope };

  switch (scope) {
    case OTP_SCOPES.LOGIN_CANDIDATE:
      resultPayload.candidate_email = userDetails.email;
      resultPayload.candidate_id = userDetails.id;
      break;
    case OTP_SCOPES.LOGIN_USER:
      resultPayload.email = userDetails.email;
      resultPayload.user_id = userDetails.id;
      break;
    default:
      break;
  }

  return resultPayload;
};
